import {
  CheckPicker,
  CheckTreePicker,
  Loader,
  Message,
  Tooltip,
  Uploader,
  UploaderProps,
  useToaster,
  Whisper,
} from "rsuite";
import useResponsiveWidth from "../../../react-query/hooks/useResponsiveWidth";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import {
  useWireContractDetails,
  useWireFiltersData,
} from "../../../react-query/hooks/HWireContracts";
import { useEffect, useRef, useState } from "react";
import {
  extractArrayValuesFromKeys,
  isMonthInPastOrFuture,
  numberFormatter,
  numberFormatterOnlyInM,
  sortTreeTableDataByLastUpdated,
  sortTreeTableDataByReleaseDate,
} from "../../../utils/formatter";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { appInsights } from "../../../router/router";
import ProductInfoIcon from "../../../assets/info-circle-grey.svg";
import SortDesc from "../../../assets/sort_desc.svg";
import SortAsc from "../../../assets/sort_asc.svg";
import SortDefault from "../../../assets/sort_default.svg";
import CustomModal from "../../../components/custom-modal";
import { FileType } from "rsuite/esm/Uploader";
import FileUploadIcon from "@rsuite/icons/FileUpload";
import Button from "../../../components/button";
import UserGuideDownloadIcon from "../../../assets/user-guide-download-white.svg";
import { useWireContractUploadSubmit } from "../../../react-query/hooks/HWireContractUpload";
import { useAppSelector } from "../../../services/redux/hooks/hooks";

function Wirecontracts() {
  const width = useResponsiveWidth();

  const userData = useAppSelector((state) => state.user);

  const [filters, setFilters] = useState<any>({
    stockProjects: [],
    districts: [],
    vendors: [],
    releaseDate: [],
    contractIds: [],
    status: [],
  });

  const [filtersQueries, setFiltersQueries] = useState<any>({
    stockProjects: [],
    districts: [],
    vendors: [],
    releaseDate: [],
    contractIds: [],
    status: [],
  });
  const {
    wireFilters,
    isLoading,
    refetch: filtersDataRefetch,
  } = useWireFiltersData(filtersQueries);
  const [districts, setDistricts] = useState<any[]>([]);
  const [isDisableApply, setDisableApply] = useState(false);
  const [vendors, setVendors] = useState<any[]>([]);
  const [stockProjects, setStockProjects] = useState<any[]>([]);
  const [releaseDate, setReleaseDate] = useState<string[]>([]);
  const [contractId, setContractId] = useState<string[]>([]);
  const [status, setStatus] = useState<string[]>([]);
  const [treeSortField, setTreeSortField] = useState<any>(null);
  const [treeSortOrder, setTreeSortOrder] = useState<any>(null);
  const [sortedData, setSortedData] = useState<any[]>([]);
  const toaster = useToaster();
  const didSetFilters = useRef(false);
  const [previousDropdown, setPreviousDropdown] = useState<any>(null);
  const [openModal, setOPenModal] = useState<boolean>(false);
  const [filesList, setFilesList] = useState<FileType[]>([]);
  const [validationMessage, setValidationMessage] = useState<string>("");
  const [isUploading, setIsUploading] = useState(false);

  const {
    data: contractData,
    isLoading: isContractLoading,
    refetch: contractDetailsRefetching,
  } = useWireContractDetails(
    userData.role_name === "DIM" && filters.stockProjects.length
      ? ["Stock"]
      : filters.stockProjects,
    filters.vendors,
    filters.districts,
    filters.releaseDate,
    filters.contractIds,
    filters.status,
  );

  const {
    mutate,
    uploadSuccess,
    setUploadSuccess,
    errorMessage,
    setErrorMessage,
  } = useWireContractUploadSubmit();

  const validationMessages = {
    fileLimit: "Only one file can be uploaded at a time.",
    fileSize: "File size should not exceed 10MB.",
    fileFormat: " Only Excel files (.xlsx, .xls) are allowed.",
  };

  // Allowed file types and max size
  const allowedTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];
  const maxSize = 10 * 1024 * 1024; // 10MB in bytes

  const resetFilters = () => {
    didSetFilters.current = false;
    setFiltersQueries({
      stockProjects: [],
      districts: [],
      vendors: [],
      releaseDate: [],
      contractIds: [],
    });
    filtersDataRefetch();
    setDistricts([]);
    setVendors([]);
    setReleaseDate([]);
    setContractId([]);
    setStatus([]);
    setStockProjects([]);
  };

  function getAppliedFilters(filtersQueries: any, wireFilters: any) {
    return {
      stockProjects:
        filtersQueries.stockProjects && filtersQueries.stockProjects.length > 0
          ? filtersQueries.stockProjects
          : extractArrayValuesFromKeys(
            wireFilters.stockProject,
            "stockProject",
          ),
      districts:
        filtersQueries.districts && filtersQueries.districts.length > 0
          ? filtersQueries.districts
          : extractArrayValuesFromKeys(wireFilters.districts, "district"),
      vendors:
        filtersQueries.vendors && filtersQueries.vendors.length > 0
          ? filtersQueries.vendors
          : extractArrayValuesFromKeys(wireFilters.vendors, "vendor"),
      releaseDate:
        filtersQueries.releaseDate && filtersQueries.releaseDate.length > 0
          ? filtersQueries.releaseDate
          : extractArrayValuesFromKeys(wireFilters.releaseDate, "releaseDate"),
      contractIds:
        filtersQueries.contractIds && filtersQueries.contractIds.length > 0
          ? filtersQueries.contractIds
          : extractArrayValuesFromKeys(wireFilters.contractId, "contractId"),
      status:
        filtersQueries.status && filtersQueries.status.length > 0
          ? filtersQueries.status
          : extractArrayValuesFromKeys(wireFilters.status, "status"),
    };
  }

  useEffect(() => {
    if (!didSetFilters.current && !isLoading) {
      setFilters({
        stockProjects: extractArrayValuesFromKeys(
          wireFilters.stockProject,
          "stockProject",
        ),
        districts: extractArrayValuesFromKeys(
          wireFilters.districts,
          "district",
        ),
        vendors: extractArrayValuesFromKeys(wireFilters.vendors, "vendor"),
        releaseDate: extractArrayValuesFromKeys(
          wireFilters.releaseDate,
          "releaseDate",
        ),
        contractIds: extractArrayValuesFromKeys(
          wireFilters.contractId,
          "contractId",
        ),
        status: extractArrayValuesFromKeys(wireFilters.status, "status"),
      });
      didSetFilters.current = true;
    }
  }, [isLoading, wireFilters]);

  const disabledLoadingDropdown = (label: string) => {
    const dropdownConfig = [
      { label: "District", key: 1 },
      { label: "Vendor", key: 2 },
      { label: "Release Date", key: 3 },
      { label: "Contract Id", key: 4 },
      { label: "Status", key: 5 },
      { label: "Stock Project", key: 6 },
    ];

    const current = dropdownConfig.find(
      (item) => item.label === previousDropdown,
    );
    const target = dropdownConfig.find((item) => item.label === label);

    if (!current || !target) return false;

    return target.key > current.key;
  };

  function safeValue(val: any) {
    return val === null || val === undefined || val === "NULL" || val === 0
      ? "-"
      : val;
  }
  function safeValueForExport(val: any) {
    return val === null ||
      val === undefined ||
      val === "NULL" ||
      val === 0 ||
      val === "-"
      ? null
      : val;
  }

  function assignTreeKeys(nodes: any[], parentKey: string = ""): any[] {
    return (nodes ?? []).map((item, idx) => {
      const key = parentKey === "" ? `${idx}` : `${parentKey}-${idx}`;
      return {
        key,
        data: {
          contractId: safeValue(item.contractId),
          district: safeValue(item.district),
          vendor: safeValue(item.vendor),
          stockProcject: safeValue(item.stockProcject),
          contractType: safeValue(item.contractType),
          parentChild: safeValue(item?.parentChild),
          lastUpdatedSource: safeValue(item?.lastUpdatedSource),
          awgStrPrice: safeValue(item.awgStrPrice),
          releaseDate: safeValue(item.releaseDate),
          commitedVolme: safeValue(item.commitedVolme),
          remainingVolume: safeValue(item.remainingVolume),
          lastUpdated: safeValue(item.lastUpdated),
          description: safeValue(item.description),
          currentPeriod: isMonthInPastOrFuture(item.releaseDate),
          status: safeValue(item.status),
          overDue: item.status === "Overdue" && item.remainingVolume > 0,
          commodityDeskContractId: safeValue(item.commodityDeskContractId),
          branch: safeValue(item.branch),
          contractStartDate: safeValue(item.contractStartDate),
          releaseMonth: safeValue(item.releaseMonth),
          priceSku: safeValue(item.priceSku),
          contractDuration: safeValue(item.contractDuration),
        },
        children: assignTreeKeys(item.children, key),
      };
    });
  }

  function assignTreeKeysForExport(
    nodes: any[],
    parentKey: string = "",
  ): any[] {
    return (nodes ?? []).map((item, idx) => {
      const key = parentKey === "" ? `${idx}` : `${parentKey}-${idx}`;
      return {
        key,
        data: {
          contractId: safeValueForExport(item.contractId),
          district: safeValueForExport(item.district),
          vendor: safeValueForExport(item.vendor),
          stockProcject: safeValueForExport(item.stockProcject),
          contractType: safeValueForExport(item.contractType),
          parentChild: safeValueForExport(item?.parentChild),
          lastUpdatedSource: safeValueForExport(item?.lastUpdatedSource),
          awgStrPrice: safeValueForExport(item.awgStrPrice),
          releaseDate: safeValueForExport(item.releaseDate),
          commitedVolme: safeValueForExport(item.commitedVolme),
          remainingVolume: safeValueForExport(item.remainingVolume),
          lastUpdated: safeValueForExport(item.lastUpdated),
          description: safeValueForExport(item.description),
          currentPeriod: isMonthInPastOrFuture(item.releaseDate),
          status: safeValueForExport(item.status),
          overDue: item.status === "Overdue" && item.remainingVolume > 0,
          commodityDeskContractId: safeValueForExport(
            item.commodityDeskContractId,
          ),
          branch: safeValueForExport(item.branch),
          contractStartDate: safeValueForExport(item.contractStartDate),
          releaseMonth: safeValueForExport(item.releaseMonth),
          priceSku: safeValueForExport(item.priceSku),
          contractDuration: safeValueForExport(item.contractDuration),
        },
        children: assignTreeKeysForExport(item.children, key),
      };
    });
  }

  const rowClassName = (node: any) => {
    return {
      "tree-row-gray":
        (node.data.parentChild === "C" ||
          (node.data.parentChild === "P" && node?.children?.length === 0)) &&
        node?.data?.status === "Closed" &&
        node?.data.remainingVolume === "-",
      "tree-row-green":
        (node.data.parentChild === "C" ||
          (node.data.parentChild === "P" && node?.children?.length === 0)) &&
        node?.data?.status === "Active",
      "tree-row-blue":
        (node.data.parentChild === "C" ||
          (node.data.parentChild === "P" && node?.children?.length === 0)) &&
        node?.data?.status === "Upcoming",
      "tree-row-red":
        (node.data.parentChild === "C" ||
          (node.data.parentChild === "P" && node?.children?.length === 0)) &&
        node?.data?.status === "Overdue" &&
        node.data.remainingVolume != 0,
    };
  };

  const handleExcelDownload = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Wire Contract Tracking Sheet");
    // Add headers and rows based on structure
    worksheet.addRow([
      "District:",
      filters.districts.length !==
        extractArrayValuesFromKeys(wireFilters.districts, "district").length
        ? filters.districts.join(", ")
        : filtersQueries.districts.length > 0
          ? filtersQueries.districts.join(", ")
          : "All",
    ]);
    worksheet.addRow([
      "Supplier:",
      filters.vendors.length !==
        extractArrayValuesFromKeys(wireFilters.vendors, "vendor").length
        ? filters.vendors.join(", ")
        : filtersQueries.vendors.length > 0
          ? filtersQueries.vendors.join(", ")
          : "All",
    ]);
    worksheet.addRow([
      "Release Month:",
      filters.releaseDate.length !==
        extractArrayValuesFromKeys(wireFilters.releaseDate, "releaseDate").length
        ? filters.releaseDate.join(", ")
        : filtersQueries.releaseDate.length > 0
          ? filtersQueries.releaseDate.join(", ")
          : "All",
    ]);

    // worksheet.addRow([
    //   "Contract ID:",
    //   filters.contractIds.length !==
    //     extractArrayValuesFromKeys(wireFilters.contractId, "contractId").length
    //     ? filters.contractIds.join(", ")
    //     : "All",
    // ]);

    worksheet.addRow([
      "Status:",
      filters.status.length !==
        extractArrayValuesFromKeys(wireFilters.status, "status").length
        ? filters.status.join(", ")
        : filtersQueries.status.length > 0
          ? filtersQueries.status.join(", ")
          : "All",
    ]);

    worksheet.addRow([
      "Stock or Project:",
      filters.stockProjects.length !==
        extractArrayValuesFromKeys(wireFilters.stockProject, "stockProject")
          .length
        ? filters.stockProjects.join(", ")
        : filtersQueries.stockProjects.length > 0
          ? filtersQueries.stockProjects.join(", ")
          : "All",
    ]);

    worksheet.addRow([]); // Empty row

    //adding headers
    worksheet.addRow([
      "Contract ID",
      "District",
      "Supplier",
      "Stock or Project",
      "Contract Type",
      "12 AWG Str.Price",
      "Release Date",
      "Committed Volume",
      "Remaining Volume",
      "Last Updated",
      "Last Update Source",
      "Parent/Child",
      "Current Period",
      "Overdue",
    ]);

    if (
      contractData &&
      contractData?.data &&
      contractData?.data?.wireContractData
    ) {
      [...assignTreeKeys(contractData?.data?.wireContractData)].forEach(
        (ele: any) => {
          worksheet.addRow([
            ele.data.contractId,
            ele.data.district,
            ele.data.vendor,
            ele.data.stockProcject,
            ele.data.contractType,
            ele.data.awgStrPrice,
            ele.data.releaseDate,
            ele.data.commitedVolme,
            ele.data.remainingVolume,
            moment(ele.data.lastUpdated).utc().format("MMM-DD-YYYY"),
            ele.data.lastUpdatedSource,
            ele.data.parentChild,
            ele.data.currentPeriod === "Current month" ? "Yes" : "No",
            ele.data.overDue ? "Yes" : "No",
          ]);
          if (ele.children) {
            ele.children.forEach((childEle: any) => {
              worksheet.addRow([
                childEle.data.contractId,
                childEle.data.district,
                childEle.data.vendor,
                childEle.data.stockProcject,
                childEle.data.contractType,
                childEle.data.awgStrPrice,
                childEle.data.releaseDate,
                childEle.data.commitedVolme,
                childEle.data.remainingVolume,
                moment(childEle.data.lastUpdated).utc().format("MMM-DD-YYYY"),
                childEle.data.lastUpdatedSource,
                childEle.data.parentChild,
                childEle.data.currentPeriod === "Current month" ? "Yes" : "No",
                childEle.data.overDue ? "Yes" : "No",
              ]);
            });
          }
        },
      );
    }

    // Apply styling to all data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber <= 5) {
        row.getCell(1).font = { bold: true }; // Make the first cell bold
        row.getCell(2).alignment = { wrapText: true };
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }
      if (rowNumber > 6) {
        if (rowNumber === 7) {
          row.font = {
            bold: true,
          };
        }
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = {
            horizontal: "left",
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
        if (rowNumber > 5) {
          [6, 8, 9].map((ele) => {
            row.getCell(ele).alignment = { horizontal: "right" };
          });
          row.getCell(6).numFmt = "$#,##0.00";
          row.getCell(10).alignment = { horizontal: "right" };
          row.getCell(10).numFmt = "mm-dd-yyyy";
        }
      }
    });

    worksheet.columns.forEach((column: any, i: number) => {
      if (i === 1) {
        column.width = 20;
      } else {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell: any) => {
          if (cell.value) {
            const cellValue = cell.value.toString();
            maxLength = Math.max(maxLength, cellValue.length);
          }
        });
        column.width = maxLength + 2;
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `Wire Contract Tracking_${moment(new Date()).format("MM-DD-YYYY")}.xlsx`,
    );
    appInsights.trackEvent({
      name: "Wire Contract tracking: Total View",
      properties: {
        description: `${localStorage.getItem(
          "userEmail",
        )} has downloaded "Wire Contract Tracking_${moment(new Date()).format(
          "MM-DD-YYYY",
        )}.xlsx" Report`,
      },
    });
  };

  const handleEXport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Contract_Details");
    //adding headers
    worksheet.addRow([
      "CONTRACT_ID",
      "COMMODITY_DESK_CONTRACT_ID",
      "CONTRACT_DESCRIPTION",
      "DISTRICT",
      "SUPPLIER",
      "BRANCH",
      "FIRM_FLOAT",
      "CONTRACT_START_DATE",
      "CONTRACT_END_DATE",
      "STOCK_PROJECT",
      "TOTAL_COMMITTED_PRODUCT_LBS",
      "TOTAL_REMAINING_PRODUCT_LBS",
      "PRICE_SKU",
      "PRICE",
      "CONTRACT_DURATION",
      "LAST_UPDATED",
      "DELETE_CONTRACT",
      "NOTES",
    ]);

    //adding data
    if (
      contractData &&
      contractData?.data &&
      contractData?.data?.wireContractData
    ) {
      [
        ...assignTreeKeysForExport(contractData?.data?.wireContractData),
      ].forEach((ele: any) => {
        if (
          !(
            ele.data.contractDuration === "Multiple Release" &&
            ele.data.parentChild === "P"
          )
        ) {
          worksheet.addRow([
            ele.data.contractId,
            ele.data.commodityDeskContractId,
            ele.data.description,
            ele.data.district,
            ele.data.vendor,
            ele.data.branch,
            ele.data.contractType,
            moment(ele.data.contractStartDate).utc().format("M/D/YYYY"),
            moment(ele.data.releaseMonth).utc().format("M/D/YYYY"),
            ele.data.stockProcject,
            ele.data.commitedVolme ? ele.data.commitedVolme : 0,
            ele.data.remainingVolume ? ele.data.remainingVolume : 0,
            ele.data.priceSku,
            ele.data.awgStrPrice,
            ele.data.contractDuration,
            moment(ele.data.lastUpdated).utc().format("M/D/YYYY"),
            "",
            "",
          ]);
        }
        if (ele.children) {
          ele.children.forEach((childEle: any) => {
            worksheet.addRow([
              childEle.data.contractId,
              childEle.data.commodityDeskContractId,
              childEle.data.description,
              childEle.data.district,
              childEle.data.vendor,
              childEle.data.branch,
              childEle.data.contractType,
              moment(childEle.data.contractStartDate).utc().format("M/D/YYYY"),
              moment(childEle.data.releaseMonth).utc().format("M/D/YYYY"),
              childEle.data.stockProcject,
              childEle.data.commitedVolme ? childEle.data.commitedVolme : 0,
              childEle.data.remainingVolume ? childEle.data.remainingVolume : 0,
              childEle.data.priceSku,
              childEle.data.awgStrPrice,
              childEle.data.contractDuration,
              moment(childEle.data.lastUpdated).utc().format("M/D/YYYY"),
              "",
              "",
            ]);
          });
        }
      });
    }

    // Apply styling to all data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) {
        row.font = {
          bold: true,
        };
      }
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = {
          horizontal: "left",
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      row.getCell(1).value = row.getCell(1).value?.toString();
      // row.getCell(1).numFmt = "@";
      [11, 12, 14].map((ele) => {
        row.getCell(ele).alignment = { horizontal: "right" };
      });
      [8, 9, 16].map((ele) => {
        row.getCell(ele).numFmt = "m/d/yyyy";
      });
      // row.getCell(6).numFmt = "$#,##0.00";
    });

    worksheet.columns.forEach((column: any, i: number) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
        if (cell.value) {
          const cellValue = cell.value.toString();
          maxLength = Math.max(maxLength, cellValue.length);
        }
      });
      column.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `Contract Summary_${moment(new Date()).format("MM-DD-YYYY")}.xlsx`,
    );
    appInsights.trackEvent({
      name: "Wire Contract tracking: Total View",
      properties: {
        description: `${localStorage.getItem(
          "userEmail",
        )} has downloaded "Contract Summary_${moment(new Date()).format(
          "MM-DD-YYYY",
        )}.xlsx" Report`,
      },
    });
  };

  function isAnyFilterQueryNotEmpty(): boolean {
    if (!filtersQueries) return false;
    return Object.values(filtersQueries).some((val) =>
      Array.isArray(val) ? val.length > 0 : !!val,
    );
  }

  useEffect(() => {
    setSortedData(
      sortTreeTableDataByReleaseDate(
        assignTreeKeys(contractData?.data?.wireContractData ?? []),
        treeSortField,
        treeSortOrder,
      ),
    );
  }, [isContractLoading, filters]);

  const handleClose = () => {
    setOPenModal(false);
  };

  const handleFileChange: UploaderProps["onChange"] = (files) => {
    if (files.length > 0) {
      const selectedFile = files[0].blobFile as File;
      if (!allowedTypes.includes(selectedFile.type)) {
        setFilesList([]);
        setValidationMessage("Only Excel files (.xlsx, .xls) are allowed.");
        return;
      }
      if (selectedFile.size > maxSize) {
        setFilesList([]);
        setValidationMessage("File size should not exceed 10MB.");
        return;
      }
      setFilesList(files);
      setValidationMessage("");
    } else {
      setFilesList([]);
      setValidationMessage("");
    }
  };

  const handleFileCheck: UploaderProps["shouldQueueUpdate"] = (files) => {
    const fileArray: FileType[] = Array.isArray(files) ? files : [files];
    if (fileArray.length > 1) {
      setValidationMessage("Only one file can be uploaded at a time.");
      return false;
    }
    const selectedFile = fileArray[0].blobFile as File;
    if (!allowedTypes.includes(selectedFile.type)) {
      setValidationMessage("Only Excel files (.xlsx, .xls) are allowed.");
      return false;
    }
    if (selectedFile.size > maxSize) {
      setValidationMessage("File size should not exceed 10MB.");
      return false;
    }
    setValidationMessage("");
    return true;
  };

  const handleWireContractUpload = () => {
    if (!filesList.length) {
      setValidationMessage("Please select a file to upload.");
      return;
    }
    setIsUploading(true);
    mutate(
      {
        file: filesList[0].blobFile as File,
        email: localStorage.getItem("userEmail") || undefined,
      },
      {
        onSuccess: () => {
          setIsUploading(false);
          setOPenModal(false);
          setFilesList([]);
          setValidationMessage("");
          // Optionally show a success message
          toaster.push(
            <Message showIcon type="success" closable>
              <strong>Wire Contract Upload Successful!</strong>
            </Message>,
            { placement: "topCenter", duration: 5000 },
          );
          resetFilters();
          contractDetailsRefetching();
        },
        onError: (error: any) => {
          setIsUploading(false);
          setValidationMessage(error?.message || "Upload failed.");
        },
      },
    );
  };

  const releaseDateHeader = (
    <span
      style={{
        cursor: "pointer",
      }}
      onClick={() => {
        let newOrder = 1;
        if (treeSortField === "releaseDate") {
          if (treeSortOrder === 1) {
            newOrder = -1;
          } else if (treeSortOrder === -1) {
            setTreeSortField(null);
            setTreeSortOrder(null);
            setSortedData(
              assignTreeKeys(contractData?.data?.wireContractData ?? []),
            );
            return;
          }
        }
        setTreeSortField("releaseDate");
        setTreeSortOrder(newOrder);
        setSortedData(
          sortTreeTableDataByReleaseDate(
            assignTreeKeys(contractData?.data?.wireContractData ?? []),
            "releaseDate",
            newOrder,
          ),
        );
      }}
    >
      <span>Release Period </span>
      <span>
        {" "}
        {treeSortField === "releaseDate" ? (
          treeSortOrder === 1 ? (
            <img
              className="inline"
              width={"10px"}
              height={"10px"}
              src={SortDesc}
            />
          ) : (
            <img
              className="inline"
              width={"10px"}
              height={"10px"}
              src={SortAsc}
            />
          )
        ) : (
          <img
            className="inline"
            width={"10px"}
            height={"10px"}
            src={SortDefault}
          />
        )}
      </span>
    </span>
  );

  const lastUpdatedHeader = (
    <span
      style={{
        cursor: "pointer",
      }}
      onClick={() => {
        let newOrder = 1;
        if (treeSortField === "lastUpdated") {
          if (treeSortOrder === 1) {
            newOrder = -1;
          } else if (treeSortOrder === -1) {
            setTreeSortField(null);
            setTreeSortOrder(null);
            setSortedData(
              assignTreeKeys(contractData?.data?.wireContractData ?? []),
            );
            return;
          }
        }
        setTreeSortField("lastUpdated");
        setTreeSortOrder(newOrder);
        setSortedData(
          sortTreeTableDataByLastUpdated(
            assignTreeKeys(contractData?.data?.wireContractData ?? []),
            "lastUpdated",
            newOrder,
          ),
        );
      }}
    >
      <span> Last Updated </span>
      <span>
        {" "}
        {treeSortField === "lastUpdated" ? (
          treeSortOrder === 1 ? (
            <img
              className="inline"
              width={"10px"}
              height={"10px"}
              src={SortDesc}
            />
          ) : (
            <img
              className="inline"
              width={"10px"}
              height={"10px"}
              src={SortAsc}
            />
          )
        ) : (
          <img
            className="inline"
            width={"10px"}
            height={"10px"}
            src={SortDefault}
          />
        )}
      </span>
    </span>
  );

  return (
    <>
      <div className={`flex flex-col h-full`}>
        <div className="ps-[3%] flex-[0.2] pr-[5%] pt-[1%] shadow-normal relative">
          <div className="flex justify-between items-center w-full">
            <div className="font-normal text-[2vw] leading-[2.2vw]">
              Wire Contract Tracking
              <br />
              <span className="font-bold text-fs16 text-[#858585]">
                Current Month:&nbsp;
                <span className="font-bold underline text-deloitteGreen">
                  {moment().utc().format("MMMM YYYY")}
                </span>
              </span>
            </div>

            <div
              className={`py-[2%] flex flex-col justify-start items-center gap-4`}
            >
              <div className={`flex justify-start items-center gap-4`}>
                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.8vw]">District</label>
                  <CheckPicker
                    sticky
                    className="dropdown-responsive-width"
                    countable={true}
                    data={wireFilters?.districts ?? []}
                    preventOverflow={true}
                    style={{ width: width }}
                    onClean={() => {
                      setDistricts([]);
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        districts: [],
                      }));
                    }}
                    onChange={(value: string[]) => {
                      setDistricts(value);
                      if (value?.length > 0) {
                        setDisableApply(true);
                      }
                    }}
                    onClose={() => {
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        districts: districts.length > 0 ? districts : [],
                      }));
                      setDisableApply(false);
                    }}
                    cleanable={true}
                    value={districts ?? []}
                    placeholder="All"
                    labelKey="district"
                    valueKey="district"
                    menuMaxHeight={150}
                  />
                </div>

                <div className="flex flex-col justify-start items-start max-w-[max(180px,10vw)]">
                  <label className="font-bold text-[0.8vw]">Supplier</label>
                  <CheckPicker
                    sticky
                    data={wireFilters?.vendors ?? []}
                    preventOverflow={true}
                    style={{ width: width }}
                    onOpen={() => { }}
                    onChange={(value: string[]) => {
                      setVendors(value);
                      if (value?.length > 0) {
                        setDisableApply(true);
                      }
                    }}
                    onClose={() => {
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        vendors: vendors.length > 0 ? vendors : [],
                      }));
                    }}
                    onClean={() => {
                      setVendors([]);
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        vendors: [],
                      }));
                    }}
                    value={vendors ?? []}
                    placeholder="All"
                    labelKey="vendor"
                    valueKey="vendor"
                    menuMaxHeight={150}
                  />
                </div>
                <div className="flex flex-col justify-start items-start max-w-[max(180px,10vw)]">
                  <label className="font-bold text-[0.8vw]">
                    Release Month
                  </label>
                  <CheckTreePicker
                    data={wireFilters?.treeReleaseDate ?? []}
                    preventOverflow={true}
                    popupStyle={{ width: "180px" }}
                    style={{ width: width }}
                    onOpen={() => { }}
                    onChange={(value: any[]) => {
                      const flatValue = value.flat();
                      setReleaseDate(flatValue);
                      if (value?.length > 0) {
                        setDisableApply(true);
                      }
                    }}
                    treeHeight={150}
                    menuMaxHeight={200}
                    onClose={() => {
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        releaseDate: releaseDate.length > 0 ? releaseDate : [],
                      }));
                      setDisableApply(false);
                    }}
                    onClean={() => {
                      setReleaseDate([]);
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        releaseDate: [],
                      }));
                    }}
                    value={releaseDate}
                    placeholder="All"
                    labelKey="label"
                    valueKey="value"
                  />
                </div>

                <Button
                  className="w-[5vw] mt-4"
                  label={"Reset"}
                  bgColor={"#86BC25"}
                  disabled={!isAnyFilterQueryNotEmpty()}
                  onClick={resetFilters}
                />
              </div>
              <div className={`flex justify-start items-center gap-4`}>
                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.8vw]">Contract ID</label>
                  <CheckPicker
                    sticky
                    className="dropdown-responsive-width"
                    countable={true}
                    data={wireFilters?.contractId ?? []}
                    preventOverflow={true}
                    style={{ width: width }}
                    onClean={() => {
                      setStockProjects([]);
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        contractIds: [],
                      }));
                    }}
                    onChange={(value: string[]) => {
                      setContractId(value);
                      if (value?.length > 0) {
                        setDisableApply(true);
                      }
                    }}
                    onClose={() => {
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        contractIds: contractId.length > 0 ? contractId : [],
                      }));
                      setDisableApply(false);
                    }}
                    cleanable={true}
                    value={contractId ?? []}
                    placeholder="All"
                    labelKey="contractId"
                    valueKey="contractId"
                    menuMaxHeight={150}
                  />
                </div>

                <div className="flex flex-col justify-start items-start max-w-[max(180px,10vw)]">
                  <label className="font-bold text-[0.8vw]">
                    Contract Status
                  </label>
                  <CheckPicker
                    sticky
                    data={wireFilters?.status ?? []}
                    preventOverflow={true}
                    style={{ width: width }}
                    onOpen={() => { }}
                    onChange={(value: string[]) => {
                      setStatus(value);
                      if (value?.length > 0) {
                        setDisableApply(true);
                      }
                    }}
                    onClose={() => {
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        status:
                          status.length > 0
                            ? status
                            : extractArrayValuesFromKeys(
                              wireFilters.status,
                              "status",
                            ),
                      }));
                      setPreviousDropdown("Status");
                      setDisableApply(false);
                    }}
                    onClean={() => {
                      setStatus([]);
                      setFiltersQueries((prev: any) => ({
                        ...prev,
                        status: extractArrayValuesFromKeys(
                          wireFilters.status,
                          "status",
                        ),
                      }));
                    }}
                    value={status ?? []}
                    placeholder="All"
                    labelKey="status"
                    valueKey="status"
                    menuMaxHeight={150}
                  />
                </div>
                {userData.role_name != "DIM" ? (
                  <div className="flex flex-col justify-start items-start max-w-[max(180px,10vw)]">
                    <label className="font-bold text-[0.8vw]">
                      Stock or Project
                    </label>
                    <CheckPicker
                      sticky
                      data={wireFilters?.stockProject ?? []}
                      preventOverflow={true}
                      style={{ width: width }}
                      onOpen={() => { }}
                      onChange={(value: string[]) => {
                        setStockProjects(value);
                        if (value?.length > 0) {
                          setDisableApply(true);
                        }
                      }}
                      onClose={() => {
                        setFiltersQueries((prev: any) => ({
                          ...prev,
                          stockProjects:
                            stockProjects.length > 0 ? stockProjects : [],
                        }));
                        setDisableApply(false);
                      }}
                      onClean={() => {
                        setStockProjects([]);
                        setFiltersQueries((prev: any) => ({
                          ...prev,
                          stockProjects: [],
                        }));
                      }}
                      value={stockProjects ?? []}
                      placeholder="All"
                      labelKey="stockProject"
                      valueKey="stockProject"
                      menuMaxHeight={150}
                    />
                  </div>
                ) : (
                  <div style={{ width: width }}></div>
                )}

                <Button
                  className="w-[5vw] mt-4"
                  label={"Apply"}
                  bgColor={"#86BC25"}
                  disabled={isLoading || isDisableApply}
                  onClick={() => {
                    if (isAnyFilterQueryNotEmpty()) {
                      const appliedFilters = getAppliedFilters(
                        filtersQueries,
                        wireFilters,
                      );
                      setFilters(appliedFilters);
                    } else {
                      console.log("Reset Filters");
                      resetFilters();
                    }
                  }}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between items-end">
            <div className="absolute bottom-0 flex justify-start items-center gap-6 text-black font-normal text-[0.8vw]">
              <span
                className={
                  "font-bold border-b-2 border-black cursor-pointer pb-[1vh]"
                }
                onClick={() => { }}
              >
                Total Blanket View
              </span>
            </div>
          </div>
        </div>
        {/* KPI BOXES */}
        <div
          className={`bg-[#F1F1F1] flex-[0.1] p-[1rem] flex justify-start items-start h-full w-full`}
        >
          <div className="flex justify-end w-[66%] ">
            <div
              className={`bg-white shadow-module-card rounded-md border border-[#BEBEBE] mr-[2%] w-[18%]`}
            >
              <div className="p-[1vh] text-center">
                <div className="font-bold text-[0.8vw]">
                  Total Committed Volume
                </div>
                <div className="font-normal text-[2.5vw]">
                  {contractData?.data.totalCommittedVolume
                    ? numberFormatterOnlyInM(
                      contractData?.data.totalCommittedVolume,
                    )
                    : "-"}
                  <span className="text-[0.8vw]">lbs</span>
                </div>
              </div>
            </div>
            <div
              className={`bg-white shadow-module-card rounded-md border border-[#BEBEBE] mr-[2%] w-[18%]`}
            >
              <div className="p-[1vh] text-center">
                <div className="font-bold text-[0.8vw]">
                  Total Volume Remaining
                </div>
                <div className="font-normal text-[2.5vw]">
                  {contractData?.data.totalRemainingVolume
                    ? numberFormatterOnlyInM(
                      contractData?.data.totalRemainingVolume,
                    )
                    : "-"}
                  <span className="text-[0.8vw]">lbs</span>
                </div>
              </div>
            </div>
            <div
              className={`bg-white shadow-module-card rounded-md border border-[#BEBEBE] mr-[2%] w-[18%]`}
            >
              <div className="p-[1vh] text-center">
                <div className="font-bold text-[0.8vw]">
                  Number of <br /> Contracts
                </div>
                <div className="font-normal text-[2.5vw]">
                  {contractData?.data?.activeContract
                    ? contractData?.data?.activeContract
                    : "-"}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 justify-center items-end self-end h-full w-[34%]">
            {userData.userCanEditArray.includes("Wire Contract Tracking") && (
              <button
                onClick={() => {
                  setOPenModal(true);
                }}
                className={`text-[0.8vw] font-semibold w-[30%] bg-deloitteGreen rounded-md text-white px-[0.8vw] py-[0.8vh]`}
              // disabled={!allowAssessment}
              >
                Upload Contracts
              </button>
            )}
            <button
              onClick={() => {
                handleExcelDownload();
              }}
              className={`flex gap-1 justify-center items-center text-[0.8vw] w-[30%]  font-semibold bg-deloitteGreen rounded-md text-white px-[0.8vw] py-[0.8vh]`}
            // disabled={!allowAssessment}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1vw"
                height="1vw"
                viewBox="0 0 12 16"
                fill="none"
              >
                <path
                  d="M14.6668 5.33464V9.20797C14.2602 8.97464 13.8135 8.81464 13.3335 8.72797V5.33464H2.66683V12.0013H8.72683C8.6935 12.2213 8.66683 12.4413 8.66683 12.668C8.66683 12.8946 8.6935 13.1146 8.72683 13.3346H2.66683C1.9335 13.3346 1.3335 12.7413 1.3335 12.0013V4.0013C1.3335 3.2613 1.92683 2.66797 2.66683 2.66797H6.66683L8.00016 4.0013H13.3335C14.0668 4.0013 14.6668 4.59464 14.6668 5.33464ZM13.3335 10.668H12.0002V13.3346H10.6668L12.6668 15.3346L14.6668 13.3346H13.3335V10.668Z"
                  fill="white"
                />
              </svg>
              Download
            </button>
            <button
              onClick={() => {
                handleEXport();
              }}
              className={`flex gap-1 justify-center items-center text-[0.8vw] w-[30%]  font-semibold bg-deloitteGreen rounded-md text-white px-[0.8vw] py-[0.8vh]`}
            // disabled={!allowAssessment}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1vw"
                height="1vw"
                viewBox="0 0 12 16"
                fill="none"
              >
                <path
                  d="M14.6668 5.33464V9.20797C14.2602 8.97464 13.8135 8.81464 13.3335 8.72797V5.33464H2.66683V12.0013H8.72683C8.6935 12.2213 8.66683 12.4413 8.66683 12.668C8.66683 12.8946 8.6935 13.1146 8.72683 13.3346H2.66683C1.9335 13.3346 1.3335 12.7413 1.3335 12.0013V4.0013C1.3335 3.2613 1.92683 2.66797 2.66683 2.66797H6.66683L8.00016 4.0013H13.3335C14.0668 4.0013 14.6668 4.59464 14.6668 5.33464ZM13.3335 10.668H12.0002V13.3346H10.6668L12.6668 15.3346L14.6668 13.3346H13.3335V10.668Z"
                  fill="white"
                />
              </svg>
              Export Data
            </button>
          </div>
        </div>
        {/* TABLE */}

        <div className="flex-[0.7] px-[1rem] bg-[#F1F1F1] ">
          <div className="h-full wire-tree-table">
            <TreeTable
              rowClassName={rowClassName}
              scrollable
              sortField={treeSortField}
              sortOrder={treeSortOrder}
              removableSort
              scrollHeight="45vh"
              value={sortedData}
            >
              <Column
                expander
                field="contractId"
                className="w-[10vw]"
                header="Contract ID"
                body={(node) => {
                  const isParent =
                    node?.data?.parentChild === "P" ||
                    (node?.children && node.children.length > 0);
                  if (isParent) {
                    return (
                      <>
                        <span>{node?.data?.contractId}</span>
                        {node?.data?.description !== null &&
                          node?.data?.description !== "-" && (
                            <span>
                              <Whisper
                                className="inline"
                                speaker={
                                  <Tooltip placement="auto">
                                    {node?.data?.description}
                                  </Tooltip>
                                }
                              >
                                {" "}
                                <img
                                  src={ProductInfoIcon}
                                  alt="info"
                                  className="w-[1.75vh] cursor-pointer inline"
                                ></img>
                              </Whisper>
                            </span>
                          )}
                      </>
                    );
                  }
                  return <span>{node?.data?.contractId}</span>;
                }}
              />
              <Column
                field="district"
                className="w-[6vw]"
                header="District"
                sortable
              />
              <Column
                sortable
                field="vendor"
                className="w-[10vw]"
                header="Supplier"
              />
              <Column
                field="stockProcject"
                className="w-[10vw]"
                header="Stock/Project"
              />
              <Column
                field="awgStrPrice"
                className="w-[6vw] text-right"
                header="12 AWG Str. Price"
                sortable
                body={(node) => {
                  return (
                    <span>
                      {node?.data?.awgStrPrice == "-"
                        ? "-"
                        : numberFormatter(node?.data?.awgStrPrice, 2, "$")}
                    </span>
                  );
                }}
              />
              <Column
                field="contractType"
                className="w-[5vw]"
                header="Contract Type"
              />

              <Column
                field="releaseDate"
                header={releaseDateHeader}
                className="text-right w-[10vw]"
              />

              <Column
                className="text-right w-[8vw]"
                sortable
                body={(node) => {
                  return (
                    <span>
                      {node?.data?.commitedVolme == "-"
                        ? "-"
                        : numberFormatter(node?.data?.commitedVolme, 1)}
                    </span>
                  );
                }}
                field="commitedVolme"
                header="Committed Volume"
              />
              <Column
                sortable
                className="text-right w-[8vw]"
                body={(node) => {
                  return (
                    <span>
                      {node?.data?.remainingVolume === "-"
                        ? "-"
                        : numberFormatter(node?.data?.remainingVolume, 1)}
                    </span>
                  );
                }}
                field="remainingVolume"
                header="Remaining Volume"
              />
              <Column
                // sortable
                className="w-[7vw]"
                body={(node) => {
                  return (
                    <span>
                      {moment(node?.data?.lastUpdated)
                        .utc()
                        .format("MMM-DD-YYYY")}
                    </span>
                  );
                }}
                field="lastUpdated"
                header={lastUpdatedHeader}
              />
            </TreeTable>
          </div>
        </div>

        <div className="fixed bottom-0 w-full px-[1rem] py-[0.4rem] bg-[#F1F1F1] flex justify-start items-center font-bold text-fs16 rounded-md z-50">
          <div className="flex bg-[#F1F1F1] self-end justify-end items-center flex-nowrap gap-4">
            <div className="font-bold">Status :</div>
            <div className="flex gap-1 items-center">
              <span
                style={{ background: "rgba(180, 180, 180, 0.1)" }}
                className="w-[2.5vh] h-[2.5vh]"
              ></span>
              <span className="font-semibold text-[1.5vh]">Closed</span>
            </div>
            <div className="flex gap-1 items-center">
              <span
                style={{ background: "rgba(193, 230, 90, 0.25)" }}
                className="w-[2.5vh] h-[2.5vh]"
              ></span>
              <span className="font-semibold text-[1.5vh]">Active</span>
            </div>
            <div className="flex gap-1 items-center">
              <span
                style={{ background: "rgba(90, 160, 230, 0.1)" }}
                className="w-[2.5vh] h-[2.5vh]"
              ></span>
              <span className="font-semibold text-[1.5vh]">Upcoming</span>
            </div>
            <div className="flex gap-1 items-center">
              <span
                style={{ background: "rgba(255, 70, 70, 0.1)" }}
                className="w-[2.5vh] h-[2.5vh]"
              ></span>
              <span className="font-semibold text-[1.5vh]">Overdue</span>
            </div>
          </div>
        </div>
      </div>
      {isContractLoading && (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.8, zIndex: 9999 }}
        />
      )}
      {openModal && (
        <CustomModal
          openModal={openModal}
          closeModal={handleClose}
          isloading={isUploading}
          header={"Upload Contracts"}
          footer="Upload an excel (.xlsx, .xls) with size less than 10MB"
        >
          <div>
            <div className="px-[1vh] py-[1vh] w-[25%]">
              <a
                download={"Contract Summary Upload Template"}
                style={{ textDecoration: "none" }}
                href={require("../../../assets/contract_upload_summary_template.xlsx")}
              >
                <div className="cursor flex justify-center items-center bg-deloitteGreen rounded px-[1.2vw] py-[1vh] mr-[1.5vw] w-full">
                  <img
                    className="h-[2vh]"
                    src={UserGuideDownloadIcon}
                    alt="Download User Guide"
                  />
                  <button
                    onClick={() => { }}
                    // disabled={uploadStatus.uploadAgentPricing}
                    className={`text-[1.8vh] font-semibold text-white ml-[0.5vw]  `}
                  >
                    Template
                  </button>
                </div>
              </a>
            </div>
            <div className="px-[1vh]">
              <Uploader
                autoUpload={false}
                fileList={filesList}
                action="#"
                draggable
                shouldQueueUpdate={handleFileCheck}
                onChange={handleFileChange}
                accept=".xlsx,.xls"
                multiple={false}
              >
                <div
                  style={{
                    height: "12vw",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FileUploadIcon
                    style={{ fontSize: "5vw", color: "#86BC25" }}
                  />
                  <span className="text-fs16 mt-[2vh]">
                    Click or Drag files to this area to upload
                  </span>
                </div>
              </Uploader>
            </div>
            {validationMessage && (
              <div className="text-[0.75vw] font-semibold text-red-700 w-full flex justify-start px-[1vh]">
                *{validationMessage}
              </div>
            )}
            <div className="flex justify-center pt-[1vh]">
              <Button
                className="w-[5vw]"
                label={"Submit"}
                bgColor={"#86BC25"}
                onClick={handleWireContractUpload}
                disabled={isUploading || !filesList.length}
              />
            </div>
          </div>
        </CustomModal>
      )}
    </>
  );
}

export default Wirecontracts;
